import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be21e704"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-350" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-delete-title" }, "Delete Question to", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-delete-question-name" }, " Select Questions that you want to delete for partner ", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_confirm_delete_modal = _resolveComponent("confirm-delete-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_modal, {
      "is-visible": _ctx.isOpen && !_ctx.confirmDeleteModal.isOpen.value
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_DropDown, { class: "mb-32 ml-20 w-100" }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentOption.name), 1)
            ]),
            list: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option.name,
                  onClick: ($event: any) => (_ctx.setOption(option))
                }, _toDisplayString(option.name), 9, _hoisted_4))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          class: "mx-1",
          variant: "base",
          onClick: _ctx.handleOpenConfirmDeleteModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Delete")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_base_button, {
          class: "mx-1",
          variant: "outlined",
          onClick: _ctx.onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(_component_the_modal, { "is-visible": _ctx.questionCreateConfirmIsOpen }, {
      content: _withCtx(() => [
        _createElementVNode("p", _hoisted_5, "Your question has been Deleted " + _toDisplayString(_ctx.currentOption.placeholderName) + ".", 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'dashboard'})))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Back to Dashboard")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(_component_confirm_delete_modal, {
      "is-open": _ctx.confirmDeleteModal.isOpen.value,
      title: "Are you sure you want to delete?",
      subtitle: `Type delete to remove this question ${_ctx.currentOption.placeholderName}`,
      "confirm-button-text": "Delete data",
      onOnConfirm: _ctx.onDelete,
      onOnCancel: _ctx.confirmDeleteModal.close
    }, null, 8, ["is-open", "subtitle", "onOnConfirm", "onOnCancel"])
  ], 64))
}